export default __webpack_public_path__ + "static/media/assess-walk-1.c574efa9.gif";